import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initPWA, onUpdateReady } from './lib/pwa';

// Register PWA service worker via vite-plugin-pwa virtual module.
// The `registerSW` call inside initPWA() replaces the manual SW registration
// and handles the full install / update / offline-ready lifecycle.
initPWA();

// Show a non-blocking update toast when a new version is available.
onUpdateReady((applyUpdate) => {
  // Create a minimal toast DOM node — avoids React hydration complexity
  const toast = document.createElement('div');
  toast.setAttribute('role', 'alert');
  toast.style.cssText = `
    position: fixed; bottom: calc(80px + env(safe-area-inset-bottom));
    left: 50%; transform: translateX(-50%);
    background: #1a1a1a; color: #f2f2f2;
    border: 1px solid #2e2e2e; border-radius: 16px;
    padding: 12px 20px; font-size: 13px; font-family: system-ui, sans-serif;
    display: flex; align-items: center; gap: 12px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.7);
    z-index: 9999; white-space: nowrap;
  `;
  toast.innerHTML = `
    <span>🔄 New version available</span>
    <button id="fe-update-btn" style="
      background: #7c3aed; color: white; border: none;
      border-radius: 10px; padding: 6px 14px; font-size: 12px;
      font-weight: 600; cursor: pointer;
    ">Update</button>
  `;
  document.body.appendChild(toast);
  document.getElementById('fe-update-btn')?.addEventListener('click', () => {
    applyUpdate();
    toast.remove();
  });
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
